import $ from 'jquery'
import 'parsleyjs'
import 'parsleyjs/src/i18n/fr'
import { Alert } from '../functions'

const object = vnObject

const identityForm = $('.js-identity-form')

if (identityForm.length) {
    identityForm.parsley().on('form:success', function () {
        identityForm.attr('data-success', 'true')
    })

    identityForm.parsley().on('form:error', function () {
        identityForm.attr('data-success', 'false')
    })

    identityForm.on('submit', function (e) {
        e.preventDefault()
        e.stopPropagation()

        const formData = new FormData(identityForm[0])
        formData.append('action', 'vn_update_identity')
        formData.append('nonce', object.nonce)

        const $identityForm = identityForm
        $.ajax({
            url: object.ajaxUrl,
            type: 'POST',
            data: formData,
            beforeSend: () => {
                $identityForm.addClass('sending')
                Alert('warning', object.formWait, false)
            },
            processData: false,
            contentType: false,
            success: (res) => {
                $identityForm.removeClass('sending')

                Alert(res.success, res.data.message)
                location.reload();
            },
        })
    })
}

const addressForm = $('.js-address-form')

if (addressForm.length) {
    addressForm.parsley().on('form:success', function () {
        addressForm.attr('data-success', 'true')
    })

    addressForm.parsley().on('form:error', function () {
        addressForm.attr('data-success', 'false')
    })

    addressForm.on('submit', function (e) {
        e.preventDefault()
        e.stopPropagation()

        const formData = new FormData(addressForm[0])
        formData.append('action', 'vn_update_address')
        formData.append('nonce', object.nonce)

        const $addressForm = addressForm
        $.ajax({
            url: object.ajaxUrl,
            type: 'POST',
            data: formData,
            beforeSend: () => {
                $addressForm.addClass('sending')
                Alert('warning', object.formWait, false)
            },
            processData: false,
            contentType: false,
            success: (res) => {
                $addressForm.removeClass('sending')

                Alert(res.success, res.data.message)
                res.success && $addressForm[0].reset()
                location.reload()
            },
        })
    })
}

$('.js-delete-payment').on( 'click', function() {
    const formData = new FormData()
    formData.append('action', 'vn_remove_payment')
    formData.append('payment_id', $(this).data('id'))
    $.ajax({
        url: object.ajaxUrl,
        type: 'POST',
        data: formData,
        beforeSend: () => {
            Alert('warning', object.formWait, false)
        },
        processData: false,
        contentType: false,
        success: (res) => {
            Alert(res.success, res.data.message)
            location.reload()
        },
    })
})

$('.js-set-default-payment').on( 'click', function() {
    const formData = new FormData()
    formData.append('action', 'vn_set_default_payment')
    formData.append('payment_id', $(this).data('id'))
    formData.append('customer_id', $(this).data('customer-id'))
    $.ajax({
        url: object.ajaxUrl,
        type: 'POST',
        data: formData,
        beforeSend: () => {
            Alert('warning', object.formWait, false)
        },
        processData: false,
        contentType: false,
        success: (res) => {
            Alert(res.success, res.data.message)
            location.reload()
        },
    })
})

const billingInput = document.getElementById('billing_address');

if ( billingInput != undefined ) {
    var $departmentInput = $('#zip_code');
    var $cityInput = $('#city');
    var $countryInput = $('#country');
    var $addressInput = $('#billing_address');

    const registerOptions = {
        fields: ['address_components', 'name' ],
        componentRestrictions: { country: 'fr' },
        strictBounds: false,
    };

    const registerAddressSearchBox = new google.maps.places.Autocomplete(billingInput, registerOptions);

    registerAddressSearchBox.addListener('place_changed', () => {
        const place = registerAddressSearchBox.getPlace();

        let department = '';
        let city = '';
        let country = '';
        let streetNumber = '';
        let streetName = '';

        for (const component of place.address_components) {
            if (component.types.includes('locality')) {
                city = component.long_name;
            }
            if (component.types.includes('postal_code')) {
                department = component.long_name;
            }
            if (component.types.includes('country')) {
                country = component.short_name;
            }
            if (component.types.includes('street_number')) {
                streetNumber = component.long_name + ' ';
            }
            if (component.types.includes('route')) {
                streetName = component.long_name;
            }
        }

        $cityInput.val(city);
        $addressInput.val(streetNumber + streetName );
        $departmentInput.val(department);
        $countryInput.val(country);
    });
}